export const HOT_LEVEL = { id: 'hot', name: '热门', aliaName: '全网' };

export const SALARY_RANK = 'salary_rank';

export const OPEN_JOB_RANK = 'open_job_rank';
